import MediaReleasesAds from "./MediaReleasesAds";

export default MediaReleasesAds;
